import React from "react";
import { Alert, AlertTitle } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { SET_ERROR_PROMPT_DISRUPTION } from "../../../store/actionTypes/smrt/disruptionActionType";
import { useTranslation } from "react-i18next";

const DisruptionErrorPrompt = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    isErrorPromptDisruptionPage: isError,
    errorMessageDisruptionPage: errorMessage,
  } = useSelector((state) => state.smrtDisruption);

  const handleClose = (event, reason) => {
    dispatch({ type: SET_ERROR_PROMPT_DISRUPTION, payload: false });
  };

  return (
    isError && (
      <Alert
        sx={{ my: 2 }}
        severity="error"
        variant="filled"
        onClose={handleClose}
      >
        <AlertTitle>{t("errorPromptTitle")}</AlertTitle>
        {errorMessage}
      </Alert>
    )
  );
};

export default DisruptionErrorPrompt;
